import { useTranslation } from "react-i18next";
import "../../../i18n";
import SectionLabel from "../components/SectionLabel";

const STEP_KEYS = ["s1", "s2", "s3", "s4"];

function HowItWorks() {
  const { t } = useTranslation("marketing");

  return (
    <section className="ul-section ul-hiw-section">
      <div className="ul-center" style={{ marginBottom: 52 }}>
        <SectionLabel>{t("howItWorks.label")}</SectionLabel>
        <h2 className="ul-section-title">{t("howItWorks.title")}</h2>
        <p className="ul-section-sub">{t("howItWorks.sub")}</p>
      </div>
      <div className="ul-steps-grid">
        {STEP_KEYS.map((s, i) => (
          <div className="ul-step-item" key={s}>
            <div className="ul-step-num">{i + 1}</div>
            <div className="ul-step-title">{t(`howItWorks.steps.${s}.title`)}</div>
            <div className="ul-step-desc">{t(`howItWorks.steps.${s}.desc`)}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HowItWorks;
